import { render, staticRenderFns } from "./research-list-compose.vue?vue&type=template&id=16c5523e&"
import script from "./research-list-compose.vue?vue&type=script&lang=ts&"
export * from "./research-list-compose.vue?vue&type=script&lang=ts&"
import style0 from "./research-list-compose.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports